<template>
  <div v-if="isDataLoaded" id="view-coache-container">
    
    <div class="container is-fluid levebar-container">
      <nav class="level app-levelbar">
        <div class="level-left is-hidden-mobile">
          <breadcrumb v-if="breadcrumbList" :list="breadcrumbList"></breadcrumb>
        </div>
      </nav>
    </div>

    <div id="view-coach">
      <coach-info :coach="coach"></coach-info>
      <coach-screensaver :coach="coach"></coach-screensaver>
      <coach-categories></coach-categories>
    </div>
  </div>
</template>

<script>
  import Breadcrumb from '../Util/Breadcrumb'
  import CoachInfo from './CoachInfo'
  import CoachScreensaver from './CoachScreensaver'
  import CoachCategories from './CoachCategories'

  export default {
    components: {
      Breadcrumb,
      CoachInfo,
      CoachScreensaver,
      CoachCategories
    },

    data () {
      return {
        breadcrumbList: null,
        isDataLoaded: false
      }
    },

    mounted () {
      this.getCoachData()
    },

    computed: {
      currentEvent () {
        return window.store.state.event.nextEvent
      },

      coach () {
        return this.$store.state.coach.data
      }
    },

    methods: {
      getCoachData () {
        this.$store.dispatch('getCoach', this.$store.state.route.params.id)
      }
    },

    watch: {
      currentEvent: function (val) {
      },

      coach: function (val) {
        if (val) {
          let id = val.id
          let name = val.languages[0].pivot.name

          this.breadcrumbList = [
            { name: 'Início', path: '/' },
            { name: `${name}`, path: `/${id}` }
          ]

          this.isDataLoaded = true
        }
      }
    }
  }
</script>

<style lang="scss">
  .content-padding {
    padding: 10px;
    background: white;
  }

  .container-margin-top {
    margin-top: 20px !important;
  }

  .flex-container-center {
    display: flex;
    align-items: center;
  }

  .app-levelbar {
    margin-bottom: 20px !important;
  }
</style>


// WEBPACK FOOTER //
// Coach.vue?14aebb28